var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    { staticClass: "mb-0" },
    [
      _vm._t("labelText", function () {
        return [
          _vm._v(
            _vm._s(_vm._f("trans")("Total file size per conversion")) + ":"
          ),
          _c("br"),
        ]
      }),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedSize,
              expression: "selectedSize",
            },
          ],
          staticClass: "bg-white px-2 py-1 mt-2",
          attrs: { disabled: _vm.disabled },
          on: {
            change: function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selectedSize = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
          },
        },
        _vm._l(_vm.selectableSizes, function (label, size) {
          return _c(
            "option",
            {
              attrs: { disabled: _vm.isDayBillingSelected && size < 1000 },
              domProps: { value: size },
            },
            [_vm._v("\n            " + _vm._s(label) + "\n        ")]
          )
        }),
        0
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }